export default "__VITE_ASSET__DGMcPbLl__"